"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultFont = getDefaultFont;
exports.getFontMapping = exports.getDefaultFontParams = void 0;
exports.getUsedCustomFontsInEditor = getUsedCustomFontsInEditor;
var _first = _interopRequireDefault(require("lodash/first"));
var _each = _interopRequireDefault(require("lodash/each"));
var _find = _interopRequireDefault(require("lodash/find"));
var _get = _interopRequireDefault(require("lodash/get"));
var _createSelector = _interopRequireDefault(require("../../../Utils/Function/createSelector"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var escapeQuotes = function escapeQuotes(str) {
  return str.replace(/(['"])/g, '\\$1');
};
function getDefaultFont(state) {
  var fonts = state.fonts;
  return (0, _find["default"])(fonts, {
    isDefault: true
  }) || (0, _first["default"])(fonts);
}
var getDefaultFontParams = exports.getDefaultFontParams = function getDefaultFontParams(state) {
  var stringify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var defaultFont = getDefaultFont(state);
  var fontParams = {
    'font-family': "\"".concat(escapeQuotes(defaultFont.family), "\""),
    'font-weight': 'normal',
    'font-style': 'normal'
  };
  return stringify ? Object.keys(fontParams).map(function (prop) {
    return "".concat(prop, ": ").concat(fontParams[prop], ";");
  }).join(' ') : fontParams;
};
var getFontMapping = exports.getFontMapping = (0, _createSelector["default"])(function (_ref) {
  var fonts = _ref.fonts;
  return fonts;
}, function (fonts) {
  var typeToUrlProp = {
    regular: 'urlRegular',
    bold: 'urlBold',
    italic: 'urlItalic',
    boldItalic: 'urlBoldItalic'
  };
  var typeKeys = Object.keys(typeToUrlProp);
  var fontMapping = {};
  (0, _each["default"])(fonts, function (font) {
    fontMapping[font.family] = {};
    (0, _each["default"])(typeKeys, function (typeKey) {
      var fontUrl = font[typeToUrlProp[typeKey]];
      if (fontUrl) {
        fontMapping[font.family][typeKey] = fontUrl;
      }
    });
  });
  return fontMapping;
});
function getUsedCustomFontsInEditor(state) {
  var usedCustomFonts = [];
  var designdata = (0, _get["default"])(state, 'configurator.configuration.designdata') || {};
  Object.values(designdata).forEach(function (designAreaData) {
    var objects = (0, _get["default"])(designAreaData, 'canvasData.objects') || [];
    objects.filter(function (_ref2) {
      var type = _ref2.type;
      return type === 'Text';
    }).forEach(function (_ref3) {
      var fontItem = _ref3.fontItem;
      if (fontItem.isCustomFont) {
        var customFontObj = _objectSpread(_objectSpread({}, getDefaultFont(state)), fontItem);
        !(0, _find["default"])(usedCustomFonts, customFontObj) && usedCustomFonts.push(customFontObj);
      }
    });
  });
  return usedCustomFonts;
}